var path = '/configuration/organizationBrowser/manageOrganization/formViewer/manageOrganizationFormViewer.tpl.html';
var html = "<ui-form-viewer form-id=\"{{ ::viewModel.formId }}\"\n                printable=\"false\"\n                display-form-name=\"true\">\n</ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;